import React, { createContext, useState, useContext, useLayoutEffect } from "react";
import PropTypes from "prop-types";
import { useApolloClient } from "@apollo/client";
import { HELPBUTTON_POPOVER_OPEN_QUERY } from "features/helpButton/queries";

export const AreasWrapper = ({ children }) => (
  <HeaderProvider>
    <FooterProvider>{children}</FooterProvider>
  </HeaderProvider>
);
AreasWrapper.propTypes = { children: PropTypes.element.isRequired };

export const HeaderContext = createContext();
export const HeaderProvider = ({ children }) => (
  <HeaderContext.Provider value={useState(null)}>{children}</HeaderContext.Provider>
);
HeaderProvider.propTypes = { children: PropTypes.element.isRequired };
export const useHeader = (initialHeader) => {
  const client = useApolloClient();
  const [get, set] = useContext(HeaderContext);

  useLayoutEffect(() => {
    if (!initialHeader) {
      client.writeQuery({
        query: HELPBUTTON_POPOVER_OPEN_QUERY,
        data: {
          helpButton: {
            popoverOpen: false,
          },
        },
      });
      return;
    }

    set(initialHeader);
    return () => set(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [get, set];
};

export const FooterContext = createContext();
export const FooterProvider = ({ children }) => (
  <FooterContext.Provider value={useState(null)}>{children}</FooterContext.Provider>
);
FooterProvider.propTypes = { children: PropTypes.element.isRequired };
export const useFooter = (initialFooter) => {
  const [get, set] = useContext(FooterContext);

  useLayoutEffect(() => {
    if (!initialFooter) {
      return;
    }

    set(initialFooter);
    return () => set(null);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return [get, set];
};
